import fetch, { parseListResponse, parseResponse, parseFileResponse } from "./fetch";

export interface SecteurInterface {
    interface: {
        name: string;
    };
}
export interface FamilleInterface {
    interface: {
        name: string;
    };
}

export interface ProduitIngredientListe {
    ingredient_liste: string;
}

export interface ProduitInterface {
    id: string;
    libel: string;
    marque_libel: string;
    code_barre: string;
    outre_mer: string;
    denomination_vente: string;
    nb_unite: number;
    poids_net_g: number;
    volume_net_mL: number;
    unitemesure_poids_net_libel: string;
    derniere_anneeh: number;
    secteur: SecteurInterface;
    famille: FamilleInterface;
    produit_constituants: any[];
    produit_modifications: any[];
    produit_ingredient_listes: any[];
    produit_ingredients: ProduitIngredientListe[];
    produit_etiquetages_simplifies: any[];
    produit_labels: any[];
    produit_allegations: any[];
    produit_sources: any[];
    source_principale: any[];
}

export interface nutrimentsInterface {
    nutriment: string;
    unite: string;
    type_unite: string;
    id_constituant: number;
    id_constituant_std: number;
    observations: number;
    quantite: number | null;
    quartiles: quartilesInterface;
}

export interface quartilesInterface {
    median: number;
    min: number;
    max: number;
    low: number;
    high: number;
    average: number;
    quartile1: number;
    quartile3: number;
    ecart_interquartile: number;
    outliers: number[];
}

export interface StatsInterface {
    id?: string;
    secteur: string;
    secteur_id: string;
    famille: string;
    famille_id: string;
    annee_collecte: string;
    nutriments: nutrimentsInterface[];
    produit_ids?: string;
    nb_produits?: number;
    type_marque?: string;
}

export interface OffreAlimentaireAnneesInterface {
    annee: string | number;
    produits: number;
    repartition: number;
}
export interface OffreAlimentaireAnneesMarqueInterface {
    name: string;
    annees: OffreAlimentaireAnneesInterface[];
    // annees: HashMap<OffreAlimentaireAnneesInterface>;
}
export interface OffreAlimentaireAnneesMarqueHashInterface {
    [s: string]: OffreAlimentaireAnneesMarqueInterface;
}
export interface OffreAlimentaireInterface {
    secteur_id: string | number;
    famille_id: string | number;
    secteur: string;
    famille: string;
    annees: OffreAlimentaireAnneesInterface[];
}

export interface OffreAlimentaireWithMarqueInterface {
    secteur_id: string | number;
    famille_id: string | number;
    secteur: string;
    famille: string;
    type_marque: HashMap<OffreAlimentaireAnneesMarqueInterface>;
}

class Produit {
    all(params?: HashMap<any>) {
        return parseListResponse<ProduitInterface>(fetch.get(`produits/`, { params }));
    }

    one(id: string) {
        return parseResponse<ProduitInterface>(fetch.get(`produits/${id}`));
    }

    export(params?: HashMap<any>) {
        return parseFileResponse(fetch.post(`produits/export/`, params));
    }

    // Stats
    stats(params?: HashMap<any>) {
        return parseListResponse<StatsInterface>(fetch.post(`produits/stats/`, params));
    }

    /**
     * Plan de pagination du diagramme : les colonnes candidates au grain de la
     * requête de données, sans aucune mesure. Le regroupement en graphes, leur
     * ordre et le nombre de pages se calculent côté client.
     */
    statsDiagramPlan(params?: HashMap<any>) {
        return parseResponse<{
            lignes: number[][];
            secteurs: HashMap<string>;
            familles: HashMap<string>;
            nutriments: HashMap<{ nom: string; score: number }>;
            annees: string[];
            warnings: string[];
        }>(fetch.post(`produits/stats/diagram/plan`, params));
    }

    statsExport(params?: HashMap<any>) {
        return parseFileResponse(fetch.post(`produits/stats/export/`, params));
    }

    downloadFileAnnees() {
        return parseFileResponse(fetch.get(`produits/stats/annees/file/`));
    }

    // Visualiation des données
    alimentaire(params?: HashMap<any>) {
        return parseListResponse<OffreAlimentaireInterface>(fetch.post(`produits/offre_alimentaire/`, { params }));
    }
    alimentaireWithMarque(params?: HashMap<any>) {
        return parseListResponse<OffreAlimentaireWithMarqueInterface>(
            fetch.post(`produits/offre_alimentaire/`, { params })
        );
    }
    alimentaireExport(params?: HashMap<any>) {
        return parseFileResponse(fetch.post(`produits/offre_alimentaire/export/`, params));
    }
    alimentaireExportMarque(params?: HashMap<any>) {
        return parseFileResponse(fetch.post(`produits/offre_alimentaire/export/type_marque`, params));
    }
}

export default new Produit();
